import { getStmCartValues } from '@cart-services/hooks/use-stm-cart-store'
import { useEffectOnce } from '@dni-react-hooks/use-effect-once'
import { AiPurchaseOrder } from '../../fp-b2b-shared/ai-purchase-order/AiPurchaseOrder'
import { useActiveBrands, useStmQuickOrderStore } from '../hooks'
import { BrandSelect } from './components/BrandSelect/BrandSelect'
import { DialogCsvValidationResult } from './components/DialogCsvValidationResult/DialogCsvValidationResult'
import { useCsvValidationSubmit } from './hooks/use-csv-validation-submit'

export const QuickOrder = () => {
  const activeBrands = useActiveBrands()
  const selectedProjectCode = useStmQuickOrderStore(state => state.selectedProjectCode)
  const resetSelectedProjectCode = useStmQuickOrderStore(state => state.resetSelectedProjectCode)
  const { submit: submitCsv, isSubmitting: isCsvSubmitting } = useCsvValidationSubmit()

  // 品牌選擇只對單次辨識生效，回到輸入頁就重設；但該品牌若還有進行中或已完成的辨識，重設會讓狀態機切到別的品牌而看不到它
  useEffectOnce(function resetBrandSelectionOnEntry() {
    const selectedBrand = activeBrands.find(brand => brand.projectCode === selectedProjectCode)
    const hasActiveOrder = !!selectedBrand && !!getStmCartValues(selectedBrand.campaignId).butler.orderId
    if (!hasActiveOrder) resetSelectedProjectCode()
  })

  return (
    <>
      <AiPurchaseOrder brandSelector={<BrandSelect />} onCsvSubmit={submitCsv} isCsvSubmitting={isCsvSubmitting} />
      <DialogCsvValidationResult />
    </>
  )
}
